import { InstanceAccess } from '@wellesley/openapi'
import { Earth, Lock } from 'lucide-react'

export const getAccessVisibilityIcon = (
  accessVisibility?: InstanceAccess['visibility'],
) => {
  switch (accessVisibility) {
    case 'PUBLIC':
      return <Earth size={16} color="var(--gray-500)" />
    case 'PRIVATE':
      return <Lock size={16} color="var(--gray-500)" />
    default:
      return null
  }
}
export const getAccessVisibilityText = (
  accessVisibility?: InstanceAccess['visibility'],
) => {
  switch (accessVisibility) {
    case 'PUBLIC':
      return 'Public server'
    case 'PRIVATE':
      return 'Private server'
    default:
      return null
  }
}
